import { ValidatorHelper } from "../../../../common/utility-types/helpers/ValidatorHelper";
import { Client } from "../types";

export const isClientValid = (client: Client) => {
    return ValidatorHelper.isPhoneValid(client.phone) && (client?.name ?? '').length > 0;
}

export const isEqualsClients = (fClient: Client, sClient: Client) => {
    return fClient.id == sClient.id && fClient.name == sClient.name && fClient.phone == sClient.phone;
}